// TestPlayer.js
import { configUrl } from "config";
import PdfViewer from "./PdfViewer";
import QuestionPanel from "./QuestionPanel";

export default function TestPlayer({ config, onFinish }) {
    console.log('configuration section-', config)
    return (
        <div style={{
            display: "flex",
            height: "80vh",
            overflow: "hidden",
        }}>
            {/* LEFT: PDF */}
            <div style={{
                flex: 2,
                borderRight: "1px solid #ccc",
                overflowY: "auto",
            }}>
                < PdfViewer fileUrl={`${configUrl.AssessmentServer}${config.questionPdf}`} />
            </div>

            {/* RIGHT: Questions */}
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",   // separate scroll
                    height: "80vh",
                }}>
                <QuestionPanel config={config} onFinish={onFinish} />
            </div>
        </div >
    );
}